import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import GroupMember from "models/interfaces/group-member";
import moment from "moment";

const defaultValues: GroupMember =
    RecordUtils.defaultValuesFactory<GroupMember>({
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        legacyId: undefined,
        lastActive: undefined,
    });

export default class GroupMemberRecord
    extends Record(defaultValues)
    implements GroupMember
{
    constructor(params?: GroupMember) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    public formatLastActive(): string {
        if (this.lastActive == null) {
            return "";
        }

        return moment(this.lastActive).format("MM/DD/YYYY");
    }

    public getFirstAndLastName(): string {
        return `${this.firstName ?? ""} ${this.lastName ?? ""}`;
    }

    public with(values: Partial<GroupMember>): GroupMemberRecord {
        return new GroupMemberRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
